export default __webpack_public_path__ + "static/media/product-test-protection-details.c42103b7.png";